import { Candlestick, mixins } from 'vue-chartjs-financial'
const { reactiveProp } = mixins

export default {
  name: 'candle-chart',
  extends: Candlestick,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            xAxes: [{
                ticks: {
                    autoSkip: true,
                },
            }],
        },
        legend: {
          display: false
        }
      },
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
}